import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getProductosActivos`, method: 'GET', body: null, token: token})
}